module.exports = __webpack_public_path__ + "img/intro_no.a3326e50.svg";